import React, { useState } from "react";
import {
  IoCheckbox,
  IoChevronBackOutline,
  IoSquareOutline,
} from "react-icons/io5";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import {
  Dropdown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import styles from "./Signup.module.css";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [FName, setFName] = useState("");
  const [LName, setLName] = useState("");

  const [BakeryName, setBakeryName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [signupCheck, setSignupCheck] = useState(false);
  const [Language, setLanguage] = useState({
    value: "English",
    id: 1,
  });
  const [BuisnessType, setBuisnessType] = useState({
    value: "Artisan",
    id: 1,
  });
  const [ZipCode, setZipCode] = useState("");
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [ConfirmpasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [SpecialtiesOffered, setSpecialtiesOffered] = useState("");

  const onPressNext = () => {
    setStep(step + 1);
    step == 3 && navigate("/AdminSelectPlan");
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <HeadingComponent
            textAlign={"center"}
            className={styles.SignupHeading}
            text={"Signup"}
            fontFamily={"Poppins-bold"}
            color={"var(--white-color)"}
          />

          {step == 1 ? (
            <>
              <div className={styles.backDiv} onClick={() => navigate("/")}>
                <IoChevronBackOutline color="var(--white-color)" />
                <TextComponent
                  style={{ color: "var(--white-color)", cursor: "pointer" }}
                  text={"Back to login"}
                />
              </div>
              <div className={styles.textDiv}>
                <TextComponent
                  className={styles.Heading}
                  color="var(--white-color)"
                  text={"Personal Details"}
                />
              </div>
              <div className={styles.inputDiv}>
                <div className={styles.twoInputsDivs}>
                  <InputField
                    className={styles.Nameinput}
                    labelClass={styles.labelClass}
                    label={"First name"}
                    LabelColor={"var(--white-color)"}
                    placeholder={"Chris"}
                    value={FName}
                    onChange={(e) => setFName(e.target.value)}
                  />
                  <InputField
                    className={styles.Nameinput}
                    labelClass={styles.labelClass}
                    label={"Last name"}
                    LabelColor={"var(--white-color)"}
                    placeholder={"Chris"}
                    value={LName}
                    onChange={(e) => setLName(e.target.value)}
                  />
                </div>
                <Dropdown
                  className={styles.input}
                  label={"Language Preference"}
                  labelClass={styles.labelClass}
                  value={Language}
                  labelStyle={{ color: "#838383", fontSize: 18 }}
                  style={{ color: "black" }}
                  options={[
                    {
                      value: "English",
                      id: 1,
                    },
                    {
                      value: "Spanish",
                      id: 2,
                    },
                  ]}
                  onChange={(e) => setLanguage(e)}
                />
                <InputField
                  className={styles.input}
                  label={"Email"}
                  labelClass={styles.labelClass}
                  placeholder={"chris@email.com"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <PhoneInput
                  label={"Contact number"}
                  placeholder={"(301) 580-7410"}
                  InputclassName={styles.PhoneinputClassname}
                  InnerInputclassName={styles.Phoneinput}
                  LabelColor={"var(--white-color)"}
                  value={contactNo}
                  maxLength={10}
                  onChange={setContactNo}
                />
              </div>
            </>
          ) : step == 2 ? (
            <>
              <div className={styles.backDiv} onClick={() => navigate("/")}>
                <IoChevronBackOutline color="var(--white-color)" />
                <TextComponent
                  style={{ color: "var(--white-color)", cursor: "pointer" }}
                  text={"Back to login"}
                />
              </div>
              <div className={styles.textDiv}>
                <TextComponent
                  className={styles.Heading}
                  text={"Bakery Details"}
                />
              </div>
              <div className={styles.inputDiv}>
                <InputField
                  className={styles.input}
                  label={"Bakery Name"}
                  placeholder={"Bakery Name"}
                  labelClass={styles.labelClass}
                  value={BakeryName}
                  onChange={(e) => setBakeryName(e.target.value)}
                />
                <TextComponent
                  className={styles.LocationLabel}
                  text={"Location"}
                />

                <div className={styles.ThreeInputsDivs}>
                  <InputField
                    className={styles.ThreeInput}
                    placeholder={"Zip Code"}
                    type={"number"}
                    maxLength={5}
                    value={ZipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                  />
                  <InputField
                    className={styles.ThreeInput}
                    placeholder={"State"}
                    value={State}
                    onChange={(e) => setState(e.target.value)}
                  />
                  <InputField
                    className={styles.ThreeInput}
                    placeholder={"City"}
                    value={City}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
                <Dropdown
                  className={styles.input}
                  LabelColor={"var(--white-color)"}
                  labelClass={styles.labelClass}
                  label={"Business Type"}
                  value={BuisnessType}
                  labelStyle={{ color: "#838383", fontSize: 18 }}
                  style={{ color: "black" }}
                  options={[
                    {
                      value: "Artisan",
                      id: 1,
                    },
                  ]}
                  onChange={(e) => setBuisnessType(e)}
                />
                <InputField
                  className={styles.input}
                  label={"Specialties Offered"}
                  LabelColor={"var(--white-color)"}
                  labelClass={styles.labelClass}
                  placeholder={"Bread, cake"}
                  value={SpecialtiesOffered}
                  onChange={(e) => setSpecialtiesOffered(e.target.value)}
                />
              </div>
            </>
          ) : (
            <>
              <div className={styles.backDiv} onClick={() => navigate("/")}>
                <IoChevronBackOutline color="var(--white-color)" />
                <TextComponent
                  style={{ color: "var(--white-color)", cursor: "pointer" }}
                  text={"Back to login"}
                />
              </div>
              <div className={styles.textDiv}>
                <TextComponent
                  className={styles.Heading}
                  text={"Set Password"}
                  color="var(--white-color)"
                />
              </div>
              <div className={styles.inputDiv}>
                <InputField
                  labelClass={styles.labelClass}
                  className={styles.input}
                  label={"New Password"}
                  placeholder={"Enter Password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  rightIcon={
                    passwordVisible ? (
                      <LuEye size={20} color={"var(--input-icon)"} />
                    ) : (
                      <LuEyeOff size={20} color={"var(--input-icon)"} />
                    )
                  }
                  onRightIconPress={() => setPasswordVisible(!passwordVisible)}
                  type={passwordVisible ? "text" : "password"}
                />
                <InputField
                  className={styles.input}
                  label={"Confirm New Password"}
                  labelClass={styles.labelClass}
                  placeholder={"Re-Enter Password"}
                  value={ConfirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  rightIcon={
                    ConfirmpasswordVisible ? (
                      <LuEye size={20} color={"var(--input-icon)"} />
                    ) : (
                      <LuEyeOff size={20} color={"var(--input-icon)"} />
                    )
                  }
                  onRightIconPress={() =>
                    setConfirmPasswordVisible(!ConfirmpasswordVisible)
                  }
                  type={ConfirmpasswordVisible ? "text" : "password"}
                />
                <TextComponent
                  className={styles.para}
                  color={"var(--white-color)"}
                  text={
                    "Must include a mix of uppercase letters, lowercase letters, numbers, and optionally, special characters."
                  }
                />
                <div className={styles.logoutCheck}>
                  {signupCheck ? (
                    <IoCheckbox
                      color="var(--white-color)"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSignupCheck(!signupCheck)}
                    />
                  ) : (
                    <IoSquareOutline
                      style={{ cursor: "pointer" }}
                      color="var(--white-color)"
                      onClick={() => setSignupCheck(!signupCheck)}
                    />
                  )}
                  <TextComponent
                    className={styles.link}
                    text={"  I agree to terms & conditions "}
                  ></TextComponent>
                </div>
              </div>
            </>
          )}

          <div className={styles.btn}>
            <SubmitButton
              btnContainerClass={styles.btnContainer}
              textClass={styles.btntextClass}
              btnClass={`${styles.btnClass}`}
              primary
              title={step === 3 ? "Signup" : "Next"}
              onClick={onPressNext}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
